import React from 'react';
import './table-pagination.styles.scss';

function TablePagination({
  canNextPage,
  canPreviousPage,
  pageCount,
  pageIndex,
  pageSize,
  pageOptions,
  gotoPage,
  nextPage,
  previousPage,
  setPageSize,
}) {
  return (
    <div className='table-pagination-container'>
      <div>
        <span>
          Page{' '}
          <strong>
            {pageIndex + 1} of {pageOptions.length}
          </strong>{' '}
        </span>
        <span>
          | Go to page:{' '}
          <input
            className='table-pagination-input table-pagination-input-box'
            type='text'
            defaultValue={pageIndex + 1}
            onChange={(e) => {
              const pageNumber = e.target.value
                ? Number(e.target.value) - 1
                : 0;
              gotoPage(pageNumber);
            }}
            aria-label='GoToPage'
          />
        </span>
        <select
          name='pagination'
          title='pagination'
          className='table-pagination-input table-pagination-dropdown-box'
          value={pageSize}
          onChange={(e) => setPageSize(Number(e.target.value))}
        >
          {[10, 25, 50, 100, 150].map((pageSize) => (
            <option key={pageSize} value={pageSize}>
              Show {pageSize}
            </option>
          ))}
        </select>
      </div>
      <div className='table-pagination-button-container'>
        <button
          type='button'
          className='table-pagination-button'
          title='First Page'
          onClick={() => gotoPage(0)}
          disabled={!canPreviousPage}
        >
          {'<<'}
        </button>
        <button
          type='button'
          className='table-pagination-button'
          title='Previous'
          onClick={() => previousPage()}
          disabled={!canPreviousPage}
        >
          Previous
        </button>
        <button
          type='button'
          className='table-pagination-button'
          title='Next'
          onClick={() => nextPage()}
          disabled={!canNextPage}
        >
          Next
        </button>
        <button
          type='button'
          className='table-pagination-button'
          title='Last Page'
          onClick={() => gotoPage(pageCount - 1)}
          disabled={!canNextPage}
        >
          {'>>'}
        </button>
      </div>
    </div>
  );
}

export default TablePagination;
